import SpinnerBasic, {spinnerBasicOverlayTypes, spinnerBasicTypes} from '@adv-mt/mt-spinner-basic'

const Skeleton = () => <SpinnerBasic overlayType={spinnerBasicOverlayTypes.LIGHT} type={spinnerBasicTypes.FULL} />

export default Skeleton
